module.exports = __webpack_public_path__ + "img/busca-avancada-forestales.615a50e9.jpg";